export class ReceiptVersionRequest {
    public receiptAmount: number;
    public receiptTime: number;

    constructor(receiptAmount: number, receiptTime: number) {
        this.receiptAmount = receiptAmount;
        this.receiptTime = receiptTime;
    }
}
